module.exports = __webpack_public_path__ + "static/media/gsk.25524b5c.png";